import { FormControl, FormGroup } from '@angular/forms';

export const CONSTS = {
  HEADER: $localize`Location Forecast vs. Actual`,
  DATE_LABEL: $localize`Completed Date`,
};

export const LocationForecast = 'Location-ForecastvsActual';

export const CSV_FILE_COLUMN_HEADING = [
  `Route Id`,
  `Driver`,
  `Forecasted Del Stops`,
  `Actual Del Stops`,
  `% Del Stops Frcst vs. # of Stops Del`,
  `Forecasted Del Pkgs`,
  `Actual Del Pkgs`,
  `% of Del Pkgs Frcst vs. # Pkgs Actual`,
  `Total # Pkgs Del Not Frcst`,
  `Total % Pkgs Del Not Frcst`,
  `% Frcst Pkgs Not Found`,
  `# Frcst Pkgs Not Found`,
];

type LocationForecastFormField = {
  date: FormControl<Date>;
};

export type LocationForecastFormGroup =
  FormGroup<LocationForecastFormField> | null;
